export default __webpack_public_path__ + "static/media/Icon-01.5aa11b0b.png";